<script>
  // Перенос src_ui/web/src/screens/Done.tsx — дословно.
  export let identity;
  export let outfitLabel = 'Кэжуал';
  export let onEnter = () => {};
</script>

<div class="done">
  <div class="kicker">Добро пожаловать в</div>
  <div class="city">ЛОС-САНТОС</div>
  <div class="goldline"></div>
  <div class="sub">{identity.firstName}, твоя новая история начинается.</div>
  <div class="chips">
    <div class="chip">{identity.firstName} {identity.lastName}</div>
    <div class="chip">{identity.age} лет</div>
    <div class="chip">{identity.gender === 'm' ? 'Мужчина' : 'Женщина'}</div>
    <div class="chip">{outfitLabel}</div>
  </div>
  <button class="btn-gold" on:click={onEnter}>Выбрать точку появления</button>
</div>
